import React from 'react';
import {
  CHART_DASHBOARD_ARTIFACT_TYPE,
  isChartDashboardPayload,
} from '@cotera/api';
import type { ArtifactRendererProps } from './types';
import { registerArtifactRenderer } from './registry';
import { ChartDashboardView } from '@cotera/client/v0/components/charts';
import { Text } from '@cotera/client/app/components/ui';
import { ArtifactPanelExpandBar } from '../artifact-panel-expand-button';

const ChartDashboardArtifactRenderer: React.FC<ArtifactRendererProps> = ({
  artifact,
}) => {
  if (!isChartDashboardPayload(artifact.payload)) {
    return (
      <div className="flex h-full items-center justify-center p-4">
        <Text.P className="text-muted-foreground">
          Invalid dashboard data
        </Text.P>
      </div>
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col">
      <ArtifactPanelExpandBar />
      <div className="min-h-0 flex-1 overflow-auto">
        <ChartDashboardView payload={artifact.payload} />
      </div>
    </div>
  );
};

registerArtifactRenderer(
  CHART_DASHBOARD_ARTIFACT_TYPE,
  ChartDashboardArtifactRenderer
);
